import request from '@/utils/request'

export default {
  getNotificationCount: () => {
    return request.get('/notification-count/')
  },
  getNotificationList: (params) => {
    return request.get('/django_rest/notification-info/', { params })
  },
  getNotificationDetail: (notificationId) => {
    return request.get(`/django_rest/notification-info/${notificationId}/`)
  }
}
